/**
 * @generated SignedSource<<bcc9caf2e2b387cc8784db7093323fee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetGroupFilter = "COIN" | "ETC" | "ETF" | "FIAT_EARN" | "INDEX" | "LEVERAGED_TOKEN" | "METAL" | "MUTUAL_FUND" | "SECURITY_TOKEN" | "STOCK" | "TOKEN";
export type PortfolioPeriod = "DAY" | "MAX" | "MONTH" | "SIX_MONTHS" | "WEEK" | "YEAR";
export type SortOrder = "ASC" | "DESC";
export type PortfolioInput = {
  assetGroup?: AssetGroupFilter | null | undefined;
  period?: PortfolioPeriod | null | undefined;
  sortBy?: SortOrder | null | undefined;
};
export type PortfolioAssetsViewQuery$variables = {
  input?: PortfolioInput | null | undefined;
};
export type PortfolioAssetsViewQuery$data = {
  readonly portfolio: {
    readonly assets: {
      readonly edges: ReadonlyArray<{
        readonly assetBalance: PrecisionFloat | null | undefined;
        readonly fiatBalance: PrecisionFloat | null | undefined;
        readonly node: {
          readonly __typename: string;
          readonly id: string;
          readonly logoUrl: string | null | undefined;
          readonly marketCap: number | null | undefined;
          readonly name: string | null | undefined;
          readonly networkInformation?: {
            readonly defaultNetworkId: string;
            readonly networks: ReadonlyArray<{
              readonly coinNetworkId: string;
              readonly destinationTag: string | null | undefined;
              readonly id: string;
              readonly isDepositAllowed: boolean;
              readonly isOperational: boolean;
              readonly isWithdrawalAllowed: boolean;
              readonly logoUrl: string | null | undefined;
              readonly maximumTransactionPrecision: number | null | undefined;
              readonly minDepositThreshold: PrecisionFloat | null | undefined;
              readonly minWithdrawalFee: PrecisionFloat | null | undefined;
              readonly minWithdrawalThreshold: PrecisionFloat | null | undefined;
              readonly name: string | null | undefined;
              readonly smallDepositFee: PrecisionFloat | null | undefined;
              readonly smallDepositThreshold: PrecisionFloat | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly price: PrecisionFloat | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PortfolioAssetsViewQuery = {
  response: PortfolioAssetsViewQuery$data;
  variables: PortfolioAssetsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "portfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PortfolioAssetsConnection",
        "kind": "LinkedField",
        "name": "assets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioAssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatBalance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetBalance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "symbol",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "marketCap",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "price",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AssetNetworkInformation",
                        "kind": "LinkedField",
                        "name": "networkInformation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "defaultNetworkId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Network",
                            "kind": "LinkedField",
                            "name": "networks",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "coinNetworkId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "destinationTag",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isOperational",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDepositAllowed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minDepositThreshold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "smallDepositFee",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "smallDepositThreshold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maximumTransactionPrecision",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isWithdrawalAllowed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minWithdrawalFee",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minWithdrawalThreshold",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CryptoAsset",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioAssetsViewQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioAssetsViewQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "1e9cce91f81d89663c6ff4d7ea7022ca",
    "id": null,
    "metadata": {},
    "name": "PortfolioAssetsViewQuery",
    "operationKind": "query",
    "text": "query PortfolioAssetsViewQuery(\n  $input: PortfolioInput\n) {\n  portfolio(input: $input) {\n    assets {\n      edges {\n        fiatBalance\n        assetBalance\n        node {\n          id\n          symbol\n          logoUrl\n          name\n          marketCap\n          price\n          __typename\n          ... on CryptoAsset {\n            networkInformation {\n              defaultNetworkId\n              networks {\n                id\n                name\n                coinNetworkId\n                destinationTag\n                logoUrl\n                isOperational\n                isDepositAllowed\n                minDepositThreshold\n                smallDepositFee\n                smallDepositThreshold\n                maximumTransactionPrecision\n                isWithdrawalAllowed\n                minWithdrawalFee\n                minWithdrawalThreshold\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a62abbd79ca36c00c928d82f575c9706";

export default node;
